/**
 * Binding copy for ora's one client picker (story 28998). Shared by the pane's
 * email card, the launch form's Client block and the web header. Only
 * `TOAST_CLIENT_UPDATED` lives elsewhere (`pane/paneCopy.ts`).
 */
export const CLIENT_PICKER_PROMPT = "Search client name, policy number, or city";
/** Legacy mounts (v3 add-in drawer, ora triage route) keep name-only search. */
export const CLIENT_LEGACY_PROMPT = "Start typing client name or address";
export const CLIENT_CANDIDATES_LABEL = "Possible matches from this email";
export const CLIENT_NO_RESULTS = "No clients found.";
export const CLIENT_SEARCH_FAILED = "Search failed. Try again.";
export const CLIENT_POLICY_SEARCH_FAILED = "Couldn't search policy numbers.";
export const CLIENT_POLICY_SEARCH_UNAVAILABLE =
  "Policy number search isn't available here.";
export const CLIENT_POLICY_SEARCHING = "Searching policy numbers…";
export const CLIENT_RETRY = "Try again";
/** Separator between a row's detail segments (amendment 5; was " - "). */
export const CLIENT_ROW_SEPARATOR = " · ";
